// Models
import { createAssessmentPreparationCommentStoreDefaultModel } from './comment.store'
import { createAssessmentPreparationStoreDefaultModel } from './preparation.store'

const assessmentPreparationModels = {
  assessmentPreparation: createAssessmentPreparationStoreDefaultModel(),
  assessmentPreparationComment: createAssessmentPreparationCommentStoreDefaultModel(),
}

export { assessmentPreparationModels }
